import { KeyDict } from '@/types'

export default class Convertable {

  constructor (config: Object = {}) {
    for (const [key, value] of Object.entries(config)) {
      this[key] = value
    }
  }

  // Firebase does not support custom classes like Convertable, InvitedCaster, etc so we need to convert it back to 
  // regular objects, see error below.
  // Error creating cast FirebaseError: [code=invalid-argument]: Function DocumentReference.set() called with 
  // invalid data. Unsupported field value: a custom InvitedCaster object [...]

  toObject (): any {
    return Convertable.toObject(this)
  }

  static toObject (oldDict: KeyDict<any> = {}): any {
    const newDict = {}
    for (const [key, value] of Object.entries(oldDict)) {
      if (typeof value?.toObject === 'function') {
        newDict[key] = value.toObject()
      } else if (typeof value === 'object' && value !== null) {
        newDict[key] = { ...value }
      } else {
        newDict[key] = value
      }
    }
    return newDict
  }

}
